import { CustomerCardModel } from "../../models";
import { CgTrash } from "react-icons/cg";

type Props = {
  payment: CustomerCardModel;
  onDelete: () => void;
};

const SavedPaymentMethod: React.FC<Props> = ({ payment, onDelete }) => {
  return (
    <>
      <div className="payment_sec payment-card">
        <div className="payment-card-left">
          <div className="payment-card-logo">
            <img src={payment.image_url} alt="" />
          </div>

          <div className="payment-card-info">
            <div className="payment-card-title">
              <h5>{payment.masked_number}</h5>

              {/* {payment.is_default && ( */}
              <span className="default-badge">Default</span>
              {/* )} */}
            </div>

            <p>
              Expires {payment.exp_month}/{payment.exp_year}
            </p>
          </div>
        </div>

        {/* <div className="payment-card-actions">
                <button className="payment-action-btn">
                  ✏️
                </button>

                <button
                  className="payment-action-btn danger"
                  onClick={() => setShowConfirmModal(true)}
                >
                  <Trash size={18} />
                </button>
              </div> */}

        <div className="delete_colm">
          {/* <button className="icon-card">
            <MdOutlineEdit size={20} className="icon-slate" />
          </button> */}
          <button
            className="delete_btn delete_color icon-card"
            onClick={onDelete}
          >
            <CgTrash size={20} className="icon-slate" />
          </button>
        </div>
      </div>
    </>
  );
};

export default SavedPaymentMethod;
